import { render, staticRenderFns } from "./PressReleaseDetail.vue?vue&type=template&id=02ce03d4&scoped=true&"
import script from "./PressReleaseDetail.vue?vue&type=script&lang=js&"
export * from "./PressReleaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./PressReleaseDetail.vue?vue&type=style&index=0&id=02ce03d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ce03d4",
  null
  
)

export default component.exports